import { TabConfig } from "src/app/shared/ui/tabs/tabs.component";

export const CONFIGURATIONS_TABS: Array<TabConfig & { childTabs?: Array<TabConfig> }> = [
  {
    name: "concession",
    label: "CONFIGURATION_AREA.TABS.CONCESSIONS_AREA",
    childTabs: [
      {
        name: "modules",
        label: "USER_SETTINGS.INSTALLATION_MODULE"
      },
      {
        name: "incident-management",
        label: "USER_SETTINGS.INCIDENT_MANAGEMENT_MODULE"
      },
      {
        name: "three-year-plan",
        label: "USER_SETTINGS.TYP_MODULE"
      },
      {
        name: "accounting",
        label: "USER_SETTINGS.ACCOUNTING_MODULE"
      },
      {
        name: "grid-connections",
        label: "USER_SETTINGS.GRID_CONNECTIONS_MODULE"
      },
      {
        name: "street-lighting",
        label: "USER_SETTINGS.STREET_LIGHTING_MODULE"
      },
      {
        name: "kwp",
        label: "USER_SETTINGS.KWP_MODULE"
      }
    ]
  },
  {
    name: "logs",
    label: "CONFIGURATION_AREA.TABS.DOWNLOADS_AREA"
  },
  {
    name: "reports",
    label: "CONFIGURATION_AREA.TABS.REPORTING_AREA"
  }
];
